import { Navigate, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import RequireAuth from "./components/RequireAuth";
import OAuthBootstrap from "./components/OAuthBootstrap";
import InstallBanner from "./components/InstallBanner";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Hackathons = lazy(() => import("./pages/Hackathons"));
const Calendar = lazy(() => import("./pages/Calendar"));
const Insights = lazy(() => import("./pages/Insights"));
const Nest = lazy(() => import("./pages/Nest"));
const Settings = lazy(() => import("./pages/Settings"));
const ImportPage = lazy(() => import("./pages/Import"));
const JoinHackathon = lazy(() => import("./pages/JoinHackathon"));

function RouteFallback() {
  return (
    <div className="min-h-dvh grid place-items-center bg-surface text-ink">
      <div className="flex items-center gap-3 text-sm text-ink-muted">
        <span className="material-symbols-outlined animate-spin">progress_activity</span>
        Loading…
      </div>
    </div>
  );
}

function ProtectedRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/hackathons" element={<Hackathons />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/nest" element={<Nest />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/import/:token" element={<ImportPage />} />
        <Route path="/join/:code" element={<JoinHackathon />} />
        <Route path="/join" element={<JoinHackathon />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <>
      <OAuthBootstrap />
      <InstallBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        {/* Legacy /auth/callback redirect — OAuthBootstrap handles the actual flow on any route. */}
        <Route path="/auth/callback" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <ProtectedRoutes />
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );
}
